import "./ToggleValidationButton.css";
import React from "react";
import IconsEnum from "../../classes/enums/IconsEnum";
import { iconMapping } from "../../config/iconConfig";

function ToggleValidationButton({ isValidated, onToggle }) {
  const IconOff = iconMapping[IconsEnum.CLOSE];
  const IconOn = iconMapping[IconsEnum.CONFIRM];

  const handleClick = () => {
    // Only allow toggling if validation is on
    if (onToggle && isValidated) {
      onToggle(!isValidated);
    }
  };

  return (
    <div
      className={`App-toggle-validation-switch ${
        !isValidated ? "App-toggle-validation-switch-disabled" : ""
      }`}
      onClick={handleClick}
    >
      <span
        className={
          isValidated
            ? "App-toggle-validation-switch-on"
            : "App-toggle-validation-switch-off"
        }
      >
        <span className="App-toggle-validation-icon">
          {isValidated ? <IconOn /> : <IconOff />}
        </span>
      </span>
    </div>
  );
}

export default ToggleValidationButton;
